import api, { API_VERSIONS } from "@/config/api";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";

const postRetryTranscript = async (recordingId: string) => {
  const initialToken = recoverTokenInfo();

  return await api.post(
    `/${API_VERSIONS.v0}/recording/RetryTranscript`,
    {
      recordingId,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${initialToken}`,
      },
    },
  );
};

export default postRetryTranscript;
